import React, { useState, useEffect } from 'react';
import {
  Box, Button, Typography, Card, CardContent, Grid, Chip, Paper,
} from '@mui/material';

import {
  CalendarToday, EventAvailable, LocalHospital, MoneyOff, DateRange
} from '@mui/icons-material';
import timeIll from '../../assets/time.gif';


// Leave Balance Display Component
const LeaveBalanceCard = ({ leaveBalance }) => {
  const balanceItems = [
    {
      type: 'Annual Leave',
      value: leaveBalance?.ANNUAL_LEAVE || 0,
      icon: <EventAvailable />,
      color: '#4caf50',
      bgColor: '#e8f5e8'
    },
    // {
    //   type: 'Sick Leave',
    //   value: leaveBalance?.SICK_LEAVE || 0,
    //   icon: <LocalHospital />,
    //   color: '#ff9800',
    //   bgcolor: 'var(--warning-light, #fff3e0)'
    // },
    // {
    //   type: 'Unpaid Leave',
    //   value: leaveBalance?.UNPAID_LEAVE || 0,
    //   icon: <MoneyOff />,
    //   color: '#f44336',
    //   bgColor: '#ffebee'
    // }
  ];

  return (
    <Card sx={{ padding: 2, mb: 3, boxShadow: 3, position: 'relative', overflow: 'visible' }}>
      <CardContent>
        <Typography variant="h6" gutterBottom sx={{ fontSize: '1.2rem', display: 'flex', alignItems: 'center', gap: 1 }}>
          <CalendarToday color="primary" />
          Leave Balance Overview
        </Typography>
        <Grid container spacing={2}>
          {balanceItems.map((item, index) => (
            <Grid item width={'78%'} key={index}>
              <Paper
                elevation={0}
                sx={{
                  p: 2,
                  backgroundColor: item.bgColor,
                  border: `2px solid ${item.color}20`,
                  borderRadius: 2,
                  textAlign: 'center'
                }}
              >
                <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1, color: item.color, margin: 'auto' }}>
                  {React.cloneElement(item.icon, { fontSize: 'small' })}
                  <Typography variant="h4" sx={{ fontSize: '2rem', fontWeight: 'bold', color: item.color, mb: 1 }}>
                    {item.value}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 2, ml: 1 }}>
                    {item.type}
                  </Typography>
                  {/* <Chip 
                    label={`${item.value} days available`}
                    size="small"
                    sx={{ 
                      mt: 1, 
                      backgroundColor: item.color,
                      color: 'white',
                      fontWeight: 'bold'
                    }}
                /> */}
                </Box>
              </Paper>

            </Grid>
          ))}
          <><img src={timeIll} alt="Time Illustration" style={{ position: 'absolute', width: '20%', height: '80%', top: '10%', right: 20 }} /></>
        </Grid>

      </CardContent>
    </Card>
  );
};
export default LeaveBalanceCard;

// import React, { useState, useEffect } from 'react';
// import {
//   Box, Button, Typography, Card, CardContent, Grid, Chip, Paper,
// } from '@mui/material';

// import {
//   CalendarToday, EventAvailable, LocalHospital, MoneyOff, DateRange
// } from '@mui/icons-material';
// import timeIll from '../../assets/time.gif';


// // Leave Balance Display Component
// const LeaveBalanceCard = ({ leaveBalance }) => {
//   const balanceItems = [
//     {
//       type: 'Annual Leave',
//       value: Array.isArray(leaveBalance)
//         ? (leaveBalance.find(b => b.leaveType === 'ANNUAL_LEAVE')?.balance || 0)
//         : (leaveBalance?.ANNUAL_LEAVE || leaveBalance?.annual || leaveBalance?.balance || 0),
//       icon: <EventAvailable />,
//       color: '#4caf50',
//       bgColor: '#e8f5e8'
//     }
//     // {
//     //   type: 'Sick Leave',
//     //   value: Array.isArray(leaveBalance)
//     //     ? leaveBalance.find(b => b.leaveType === 'SICK_LEAVE')?.balance || 0
//     //     : leaveBalance?.SICK_LEAVE || 0,
//     //   icon: <LocalHospital />,
//     //   color: '#ff9800',
//     //   bgColor: '#fff3e0'
//     // },
//     // {
//     //   type: 'Unpaid Leave',
//     //   value: Array.isArray(leaveBalance)
//     //     ? leaveBalance.find(b => b.leaveType === 'UNPAID_LEAVE')?.balance || 0
//     //     : leaveBalance?.UNPAID_LEAVE || 0,
//     //   icon: <MoneyOff />,
//     //   color: '#f44336',
//     //   bgColor: '#ffebee'
//     // }
//   ];

//   return (
//     <Card sx={{ padding: 2, mb: 3, boxShadow: 3, position: 'relative', overflow: 'visible' }}>
//       <CardContent>
//         <Typography variant="h6" gutterBottom sx={{ fontSize: '1.2rem', display: 'flex', alignItems: 'center', gap: 1 }}>
//           <CalendarToday color="primary" />
//           Leave Balance Overview
//         </Typography>
//         <Grid container spacing={2}>
//           {balanceItems.map((item, index) => (
//             <Grid item width={'78%'} key={index}>
//               <Paper
//                 elevation={0}
//                 sx={{
//                   p: 2,
//                   backgroundColor: item.bgColor,
//                   border: `2px solid ${item.color}20`,
//                   borderRadius: 2,
//                   textAlign: 'center'
//                 }}
//               >
//                 <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1, color: item.color, margin: 'auto' }}>
//                   {React.cloneElement(item.icon, { fontSize: 'small' })}
//                   <Typography variant="h4" sx={{ fontSize: '2rem', fontWeight: 'bold', color: item.color, mb: 1 }}>
//                     {item.value}
//                   </Typography>
//                   <Typography variant="body2" color="text.secondary" sx={{ mt: 2, ml: 1 }}>
//                     {item.type}
//                   </Typography>
//                   {/* <Chip
//                     label={`${item.value} days available`}
//                     size="small"
//                     sx={{
//                       mt: 1,
//                       backgroundColor: item.color,
//                       color: 'white',
//                       fontWeight: 'bold'
//                     }}
//                 /> */}
//                 </Box>
//               </Paper>

//             </Grid>
//           ))}
//           <><img src={timeIll} alt="Time Illustration" style={{ position: 'absolute', width: '20%', height: '80%', top: '10%', right: 20 }} /></>
//         </Grid>

//       </CardContent>
//     </Card>
//   );
// };
// export default LeaveBalanceCard;